export enum UserType {
    EMAIL = 'email',
    BADGE_ONLY = 'badgeOnly',
}